import { panelTypeService } from '@/services/api/panelType.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { panelTypeModel } from '@/models/api/panelType.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PANEL_TYPE_MODULE = "api/panelType";

// ACTIONS
export const GET_ALL_PANEL_TYPE = 'getAllPanelType';
export const CREATE_PANEL_TYPE = 'createPanelType';
export const GET_PANEL_TYPE = 'getPanelType';
export const UPDATE_PANEL_TYPE = 'updatePanelType';
export const UPDATE_PANEL_TYPE_STATUS = 'updatePanelTypeStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PANEL_TYPE_SUCCESS = "allPanelTypeSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PANEL_TYPE_SUCCESS = "getPanelTypeSuccess";

export const actions = {
    [GET_ALL_PANEL_TYPE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        panelTypeService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PANEL_TYPE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PANEL_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return panelTypeService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PANEL_TYPE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return panelTypeService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PANEL_TYPE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PANEL_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return panelTypeService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PANEL_TYPE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return panelTypeService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PANEL_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PANEL_TYPE_SUCCESS](state, {data}) {
        let panelTypeList = data.data || [];
        state.list.data = panelTypeList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = panelTypeList.map(item => panelTypeModel(item));
        }
    },
    [GET_PANEL_TYPE_SUCCESS](state, data) {
        state.details = panelTypeModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
